<template>
  <swiper-content>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="addons/booth-1-header1.svg" class="header-image" />
          <h2>The best FREE weekend data plan in town.</h2>
          <p>
            Get huge data with the newest phones, anytime, anywhere with all our
            XO plans.
          </p>
          <a
            target="_blank"
            href="https://www.singtel.com/personal/products-services/mobile/postpaid-plans/comboxo?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=mobile-hotspot&utm_campaign=iphone-2020-launch"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    <!--
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="addons/booth-1-header2.svg" class="header-image" />
          <h2>Unlimited data and peace of mind with</h2>
          <img src="addons/booth-1-body2.svg" class="body-image" />
          <p>
            Infinite data. Infinite possibilities. Sign up on Combo 3 plans and
            above.
          </p>
          <p>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/add-ons/datax?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=mobile-hotspot&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button-bottom"
            >
              Find out more
            </a>
          </p>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    -->
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="addons/booth-1-header3.svg" class="header-image" />
          <h2>Unlimited support for endless peace of mind.</h2>
          <p>
            Replace or swop your device for any reason. Plus, enjoy unlimited
            Tech Assist access.
          </p>

          <a
            target="_blank"
            href="https://www.singtel.com/personal/products-services/mobile/add-ons/swop?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=mobile-hotspot&utm_campaign=iphone-2020-launch"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
export default {
  name: "AddonsPage1",
};
</script>

<style scoped></style>
